
































































































































































































































































import { Component, Vue, Emit } from 'vue-property-decorator';
import TaskFilterPeriodCheckbox from '@/components/taskList/taskFilterParts/TaskFilterPeriodCheckbox.vue'
import { TaskFilterPeriodQuery } from '@/@types/LibraryComponent';
import { FindTasksQuery } from '@/@types/Task';
import dayjs from 'dayjs';

@Component({
  components: {
    TaskFilterPeriodCheckbox
  }
})
export default class TaskFilterPeriod extends Vue {
  private limitDateMenu: boolean = false;
  private startDateMenu: boolean = false;
  private createdDateMenu: boolean = false;
  private updatedDateMenu: boolean = false;
  private limitDates: string[] = this.getThisMonth();
  private startDates: string[] = this.getThisMonth();
  private createdDates: string[] = this.getThisMonth();
  private updatedDates: string[] = this.getThisMonth();
  private isActiveLimitDates: boolean = false;
  private isActiveStartDates: boolean = false;
  private isActiveCreatedDates: boolean = false;
  private isActiveUpdatedDates: boolean = false;

  private isCloseLimitDateMenu(): void {
    this.limitDateMenu = false;
    return;
  }
  private isCloseStartDateMenu(): void {
    this.startDateMenu = false;
    return;
  }
  private isCloseCreatedDateMenu(): void {
    this.createdDateMenu = false;
    return;
  }
  private isCloseUpdatedDateMenu(): void {
    this.updatedDateMenu = false;
    return;
  }
  private getToday() {
    const today = dayjs().format('YYYY-MM-DD');
    return [today, today];
  }
  private getThisWeek() {
    const today = dayjs();
    return [today.startOf('week').format('YYYY-MM-DD'), today.endOf('week').format('YYYY-MM-DD')];
  }
  private getThisMonth() {
    const today = dayjs();
    return [today.startOf('month').format('YYYY-MM-DD'), today.endOf('month').format('YYYY-MM-DD')];
  }
  private updateLimitDates(query: TaskFilterPeriodQuery) {
    query.day || query.week || query.month || query.isPeriod ? this.isActiveLimitDates = true : this.isActiveLimitDates = false;

    if (query.day) {
      this.limitDates = this.getToday();
    }

    if (query.week) {
      this.limitDates = this.getThisWeek();
    }

    if (query.month) {
      this.limitDates = this.getThisMonth();
    }
    this.emitSortQuery();
  }
  private updateStartDates(query: TaskFilterPeriodQuery) {
    query.day || query.week || query.month || query.isPeriod ? this.isActiveStartDates = true : this.isActiveStartDates = false;

    if (query.day) {
      this.startDates = this.getToday();
    }

    if (query.week) {
      this.startDates = this.getThisWeek();
    }

    if (query.month) {
      this.startDates = this.getThisMonth();
    }
    this.emitSortQuery();
  }
  private updateCreatedDates(query: TaskFilterPeriodQuery) {
    query.day || query.week || query.month || query.isPeriod ? this.isActiveCreatedDates = true : this.isActiveCreatedDates = false;

    if (query.day) {
      this.createdDates = this.getToday();
    }

    if (query.week) {
      this.createdDates = this.getThisWeek();
    }

    if (query.month) {
      this.createdDates = this.getThisMonth();
    }
    this.emitSortQuery();
  }
  private updateUpdatedDates(query: TaskFilterPeriodQuery) {
    query.day || query.week || query.month || query.isPeriod ? this.isActiveUpdatedDates = true : this.isActiveUpdatedDates = false;

    if (query.day) {
      this.updatedDates = this.getToday();
    }

    if (query.week) {
      this.updatedDates = this.getThisWeek();
    }

    if (query.month) {
      this.updatedDates = this.getThisMonth();
    }
    this.emitSortQuery();
  }
  private get limitDateText(): string {
    if (new Date(this.limitDates[0]) > new Date(this.limitDates[1])) {
      return this.limitDates.reverse().join('～');
    } else {
      return this.limitDates.join('～');
    }
  }
  private get startDateText(): string {
    if (new Date(this.startDates[0]) > new Date(this.startDates[1])) {
      return this.startDates.reverse().join('～');
    } else {
      return this.startDates.join('～');
    }
  }
  private get createdDateText(): string {
    if (new Date(this.createdDates[0]) > new Date(this.createdDates[1])) {
      return this.createdDates.reverse().join('～');
    } else {
      return this.createdDates.join('～');
    }
  }
  private get updatedDateText(): string {
    if (new Date(this.updatedDates[0]) > new Date(this.updatedDates[1])) {
      return this.updatedDates.reverse().join('～');
    } else {
      return this.updatedDates.join('～');
    }
  }
  @Emit('emitSortQuery')
  private emitSortQuery() {
    let queryObject: Omit<FindTasksQuery, 'project-id'> = {};

    if (this.isActiveLimitDates) {
      queryObject['deadline-begin'] = this.limitDates[0];
      queryObject['deadline-end'] = this.limitDates[1];
    }

    if (this.isActiveStartDates) {
      queryObject['start-date-begin'] = this.startDates[0];
      queryObject['start-date-end'] = this.startDates[1];
    }

    if (this.isActiveCreatedDates) {
      queryObject['created-at-begin'] = this.createdDates[0];
      queryObject['created-at-end'] = this.createdDates[1];
    }

    if (this.isActiveUpdatedDates) {
      queryObject['updated-at-begin'] = this.updatedDates[0];
      queryObject['updated-at-end'] = this.updatedDates[1];
    }

    return queryObject;
  }
}
